import Vue from 'vue'
import defaultLocales from './locales.json'

const initialLocales = { ...defaultLocales }

// Make locales reactive so updates trigger view re-renders
const locales = Vue.observable(initialLocales)

export const updateLocales = (newLocales) => {
  if (!newLocales) return
  Object.keys(newLocales).forEach(key => {
    if (!newLocales[key] || Object.keys(newLocales[key]).length === 0) return
    // Use Vue.set to ensure reactivity for new properties if any,
    // though usually we are just updating existing structure.
    Vue.set(locales, key, {
      ...(locales[key] || {}),
      ...newLocales[key]
    })
  })
}

export default locales
